import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { ICRUD, ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_VENDOR_PRICE_LIST, GET_VENDOR_PRICE_LIST, GET_VENDOR_PRICE_LISTS, SAVE_VENDOR_PRICE_LIST } from "../../../data/definitions/price-list-types.definition";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DataService } from "../../../data/services/data.service";
import { DeleteVendorPriceListMutation, DeleteVendorPriceListMutationVariables, DeletionResponse, GetVendorPriceListQuery, GetVendorPriceListQueryVariables, GetVendorPriceListsQuery, GetVendorPriceListsQueryVariables, SaveVendorPriceListMutation, SaveVendorPriceListMutationVariables, SearchInput, VendorPriceList, VendorPriceListInput } from "../../../generated/generated-types";

@Injectable({
  providedIn: 'root'
})
export class VendorPriceListService extends BaseListService<VendorPriceList> implements ICRUD<VendorPriceList> {

  constructor(private dataService: DataService,
    private baseDataService: BaseDataService,
    private systemService: SystemService) {
    super();
  }
  //#region implementation
  getItems(searchInput?: SearchInput, o?: ICRUDOptions) {

    let fragment = GET_VENDOR_PRICE_LISTS;

    if (o?.currentColumnConfig) {
      this.onlyKeepSelectedGraphQLNodesNew(fragment, o.currentColumnConfig.baseView, o.currentColumnConfig.columns);
    }

    return this.baseDataService.query<GetVendorPriceListsQuery, GetVendorPriceListsQueryVariables>(
      fragment, {
      input: searchInput,
    });
  }

  getItem(id: string) {

    return this.baseDataService.query<GetVendorPriceListQuery, GetVendorPriceListQueryVariables>(
      GET_VENDOR_PRICE_LIST, {
      id: id
    });
  }

  getItemStream(id: string) {
    return this.getItem(id).mapStream(x => x.getVendorPriceList);
  }

  async getItemData(id: string): Promise<VendorPriceList> {
    let l = await lastValueFrom(this.getItem(id).single$);
    return l.getVendorPriceList as VendorPriceList;
  }

  async deleteItem(id: string): Promise<DeletionResponse> {

    let res = await lastValueFrom(this.baseDataService.mutate<DeleteVendorPriceListMutation, DeleteVendorPriceListMutationVariables>(
      DELETE_VENDOR_PRICE_LIST, {
      id: id
    }));
    return res.deleteVendorPriceList
  }

  async saveItem(vendorPriceList: VendorPriceList | VendorPriceListInput) {

    let validated = await this.systemService.validateObject<VendorPriceListInput>(vendorPriceList, "VendorPriceListInput");

    let saved = await lastValueFrom(this.baseDataService.mutate<SaveVendorPriceListMutation, SaveVendorPriceListMutationVariables>(
      SAVE_VENDOR_PRICE_LIST, {
      input: validated
    })); //VendorPriceListLink needs to be saved

    return saved.saveVendorPriceList as VendorPriceList;
  }

  // async copyVendorPriceList(vendorPriceListCopyInput:VendorPriceListCopyInput){

  //   let validated = await this.systemService.validateObject<VendorPriceListCopyInput>(vendorPriceListCopyInput, "VendorPriceListCopyInput");

  //   let saved = await this.baseDataService.mutate<CopyVendorPriceList.Mutation, CopyVendorPriceList.Variables>(
  //     COPY_VENDOR_PRICE_LIST, {
  //     input: vendorPriceListCopyInput,
  //   }
  //   ).toPromise();

  //   return saved.copyVendorPriceList as VendorPriceList;
  // }

  /**
   * @deprecated
   */
  // async copyItem(id: string){

  //   let saved = await this.baseDataService.mutate<CopyVendorPriceList.Mutation, CopyVendorPriceList.Variables>(
  //     COPY_VENDOR_PRICE_LIST, {
  //     id: id
  //   }
  //   ).toPromise();

  //   return saved.copyVendorPriceList as VendorPriceList;
  // }

  //#endregion

}
